<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">{{ isEdit ? 'Edit' : 'Add' }} Extension</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form class="extension-form" [formGroup]="form" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         <mat-form-field>
            <mat-label>Type</mat-label>
            <input
               [lcsSingleSelect]="extensionTypeSelect"
               ndtExtensionTypeSelect
               autocomplete="off"
               type="text"
               formControlName="type"
               id="extension-type"
               [extensionTypesToInclude]="extensionTypesToInclude"
               required
            />
            <ndt-extension-type-select #extensionTypeSelect isIncludeEmptyOption="false"></ndt-extension-type-select>
            @if (form.get('type')?.hasError('required')) {
            <mat-error> Extension Type is Required. </mat-error>
            }
         </mat-form-field>
         <mat-form-field>
            <mat-label>Extension Number</mat-label>
            <input matInput autocomplete="off" type="number" formControlName="number" required />
            @if (form.get('number')?.hasError('required')) {
            <mat-error> Extension Number is Required. </mat-error>
            } @if (form.get('number')?.hasError('unique')) {
            <mat-error> Extension Number already in use </mat-error>
            } @if (form.get('number')?.hasError('pattern')) {
            <mat-error> Invalid Number Format </mat-error>
            } @if (form.get('number')?.hasError('min') || form.get('number')?.hasError('max')) {
            <mat-error> Number must be between 100-99999. </mat-error>
            }
         </mat-form-field>
         <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput autocomplete="off" type="text" formControlName="name" required #nameInput />
            @if (form.get('name')?.hasError('required')) {
            <mat-error> Name is Required. </mat-error>
            }
         </mat-form-field>
         @if ( selectedExtensionType === extensionTypes.Fax || selectedExtensionType === extensionTypes.VoiceMailbox ) {
         <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput autocomplete="off" type="email" formControlName="email" />
            @if (form.get('email')?.hasError('required')) {
            <mat-error> Email is Required </mat-error>
            } @if (form.get('email')?.hasError('pattern')) {
            <mat-error> Invalid Email Address </mat-error>
            }
         </mat-form-field>
         } @if (selectedExtensionType === extensionTypes.HuntGroup) {
         <mat-form-field>
            <mat-label>Timeout</mat-label>
            <input matInput autocomplete="off" type="number" formControlName="timeout" />
            @if (form.get('timeout')?.hasError('required')) {
            <mat-error> Timeout is Required. </mat-error>
            } @if (form.get('timeout')?.hasError('min') || form.get('timeout')?.hasError('max')) {
            <mat-error>Timeout must be between {{ minTimeoutValue }} and {{ maxTimeoutValue }}</mat-error>
            }
         </mat-form-field>
         } @if (selectedExtensionType === extensionTypes.ExternalForward) {
         <mat-form-field>
            <mat-label>Forward To</mat-label>
            <input matInput autocomplete="off" type="text" formControlName="forwardTo" />
            @if (form.get('forwardTo')?.hasError('required')) {
            <mat-error> Forward Number is Required. </mat-error>
            } @if (form.get('forwardTo')?.hasError('pattern')) {
            <mat-error>Please enter a valid phone number.</mat-error>
            }
         </mat-form-field>
         } @if (selectedExtensionType === extensionTypes.AutoAttendant) {
         <div class="setup-keys-section">
            <span>Keys: {{ this.form.get('autoAttendantKeys')?.value?.length ?? '0' }}</span>
            <button type="button" title="Setup Keys" mat-stroked-button (click)="onSetupKeys()">Setup Keys</button>
         </div>
         } @if (existingExtensions?.length > 0) {
         <h4 class="extension-list-header">Added Extensions</h4>
         }
         <ul>
            @for (extension of existingExtensions; track extension) {
            <li>
               <div class="extension-list-item-wrapper">
                  <div class="account-extension-name">{{ extension.number }} - {{ extension.name }}</div>
                  <div class="account-extension-name">{{ extension.type.displayName | addSpaces }}</div>
               </div>
            </li>
            }
         </ul>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="button" title="Add and Create Another" mat-stroked-button (click)="onCreate(true)"
            >{{ isEdit ? 'Save' : 'Add' }} and Create Another</button
         >
         <button type="submit" title="Add" mat-raised-button>{{ isEdit ? 'Save' : 'Add' }}</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
